<template>
	<div class="modal fade" id="streetView" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog streetview" role="document">
            <div class="modal-content streetviewimage">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Vista de Calle</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body" id="panel_streetview" style="top: 8px; width: 100%; height: 300px;">
                </div>

                <div class="modal-footer">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            const streetView = {
                text: 'Street View',
                icon: this.getImage('street-view.svg'),
                callback: this.initStreetView,
                index: 2
            }

            this.$store.state.map.contextmenu.insertItem(streetView, streetView.index);
        },
        methods: {
            initStreetView(e) {
                window.open('https://maps.google.com/maps?q=&layer=c&cbll=' + e.latlng.lat + ',' +
                    e.latlng.lng + '&cbp=11,0,0,0,0&ll=' + e.latlng.lat + ',' + e.latlng.lng + '&z=10', '_blank');
				},
				getImage(val) {
					return require('@/assets/images/street-view/' + val);
				}
        }
    }
</script>

<style lang="css">
    .streetview {
        max-width: 600px;
    }

    .streetviewimage {
        height: 500px;
    }
</style>